var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 10.75C5.57843 10.75 6.25 10.0784 6.25 9.25C6.25 8.42155 5.57843 7.75 4.75 7.75C3.92157 7.75 3.25 8.42155 3.25 9.25C3.25 10.0784 3.92157 10.75 4.75 10.75Z",
    stroke: "#FF547D",
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 10.75C13.0784 10.75 13.75 10.0784 13.75 9.25C13.75 8.42155 13.0784 7.75 12.25 7.75C11.4215 7.75 10.75 8.42155 10.75 9.25C10.75 10.0784 11.4215 10.75 12.25 10.75Z",
    stroke: "#FF547D",
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.25V1.45C10 1.20147 9.79855 1 9.55 1H1.45C1.20147 1 1 1.20147 1 1.45V8.8C1 9.04855 1.20147 9.25 1.45 9.25H2.9875",
    stroke: "#FF547D",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 9.25H6.2876",
    stroke: "#FF547D",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.25H14.2076C14.3854 3.25 14.5466 3.35473 14.6188 3.51724L15.9612 6.5377C15.9868 6.5953 16 6.65755 16 6.72047V8.8C16 9.04855 15.7985 9.25 15.55 9.25H14.125",
    stroke: "#FF547D",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.25H10.75",
    stroke: "#FF547D",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon);
export default __webpack_public_path__ + "static/media/delivery_icon.5014bf5b1b5a630699c4d48319c29f6a.svg";
export { ForwardRef as ReactComponent };